import { render, staticRenderFns } from "./ShareRoadWays.vue?vue&type=template&id=9480fd7c&scoped=true&"
import script from "./ShareRoadWays.vue?vue&type=script&lang=js&"
export * from "./ShareRoadWays.vue?vue&type=script&lang=js&"
import style0 from "./ShareRoadWays.vue?vue&type=style&index=0&id=9480fd7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9480fd7c",
  null
  
)

export default component.exports